export const LOADED = "todos/loades";
export const ADDED = "todos/added";
export const TOGGLED = "todos/toggled";
export const COLORSELECTED = "todos/colorselected";
export const DELETED = "todos/deleted";
export const COMPLETEALL = "todos/completeall";
export const CLEARCOMPLETED = "todos/clearcompleted";
export const EDITBTN = "todos/editbtn";
export const UPDATE = "todos/update";
